import { createContext, useCallback, useMemo, useState } from "react";
import merge from "lodash/merge";
// CUSTOM COMPONENT
import { MatxLayoutSettings } from "app/components/MatxLayout/settings";

export const SettingsContext = createContext({
  settings: MatxLayoutSettings,
  updateSettings: () => {},
});

export default function SettingsProvider({ settings, children }) {
  const [currentSettings, setCurrentSettings] = useState(
    settings || MatxLayoutSettings,
  );

  // Stable identity is required: TenantBrandingApplier (and similar effects) depend on
  // updateSettings. Recreating it every render caused an infinite settings update loop
  // on tenant hosts and left session routes stuck on the Suspense/MatxLoading fallback.
  const handleUpdateSettings = useCallback((update = {}) => {
    setCurrentSettings((prev) => merge({}, prev, update));
  }, []);

  const value = useMemo(
    () => ({
      settings: currentSettings,
      updateSettings: handleUpdateSettings,
    }),
    [currentSettings, handleUpdateSettings],
  );

  return (
    <SettingsContext.Provider value={value}>{children}</SettingsContext.Provider>
  );
}
